import type { enBoApInvoices } from '../en/bo-ap-invoices';

export const idBoApInvoices: Record<keyof typeof enBoApInvoices, string> = {
  // ---- Statuses and reasons
  'bo.ap.status.draft': 'Draf',
  'bo.ap.status.under_review': 'Ditinjau',
  'bo.ap.status.approved': 'Disetujui',
  'bo.ap.status.posted': 'Diposting',
  'bo.ap.status.partially_paid': 'Dibayar sebagian',
  'bo.ap.status.paid': 'Lunas',
  'bo.ap.status.disputed': 'Disengketakan',
  'bo.ap.status.voided': 'Dibatalkan',
  'bo.ap.reason.line_not_on_po': 'Tidak ada di PO',
  'bo.ap.reason.qty_exceeds_ordered': 'Jumlah melebihi pesanan',
  'bo.ap.reason.qty_exceeds_received': 'Jumlah melebihi penerimaan',
  'bo.ap.reason.price_variance': 'Harga di luar toleransi',
  'bo.ap.reason.amount_variance': 'Total header beda dengan baris',

  // ---- Invoice list
  'bo.ap.inv.title': 'Faktur pemasok',
  'bo.ap.inv.subtitle': 'Faktur dari pemasok di {branch}: pencocokan, persetujuan, dan utang.',
  'bo.ap.inv.noBranch': 'Faktur pemasok tercatat per cabang. Buat cabang terlebih dahulu.',
  'bo.ap.inv.add': 'Catat faktur',
  'bo.ap.inv.readOnly':
    'Hanya baca: mencatat dan mengubah faktur memerlukan peran staf utang (AP).',
  'bo.ap.inv.noPermission': 'Peran Anda tidak dapat melihat faktur pemasok di cabang ini.',
  'bo.ap.inv.listTitle': 'Faktur',
  'bo.ap.inv.listDesc':
    'Terbaru di atas. Sisa utang adalah utang terbuka setelah pembayaran terverifikasi dan nota kredit yang diposting.',
  'bo.ap.inv.filter.status': 'Saring menurut status',
  'bo.ap.inv.filter.supplier': 'Pemasok',
  'bo.ap.inv.filter.allSuppliers': 'Semua pemasok',
  'bo.ap.inv.filter.openOnly': 'Hanya utang terbuka',
  'bo.ap.inv.search': 'Nomor, pemasok, atau no. faktur pemasok',
  'bo.ap.inv.empty': 'Belum ada faktur pemasok. Catat yang pertama lewat “Catat faktur”.',
  'bo.ap.inv.emptyReadOnly': 'Belum ada faktur pemasok. Faktur muncul setelah dicatat staf AP.',
  'bo.ap.inv.emptyFiltered': 'Tidak ada faktur yang sesuai saringan ini.',
  'bo.ap.inv.col.number': 'Nomor',
  'bo.ap.inv.col.supplier': 'Pemasok',
  'bo.ap.inv.col.supplierNumber': 'No. faktur {number}',
  'bo.ap.inv.col.match': 'Pencocokan',
  'bo.ap.inv.col.status': 'Status',
  'bo.ap.inv.col.pending': 'Menunggu',
  'bo.ap.inv.col.line': 'Baris',
  'bo.ap.inv.col.qty': 'Jumlah',
  'bo.ap.inv.col.price': 'Harga satuan',
  'bo.ap.inv.col.discount': 'Diskon',
  'bo.ap.inv.col.taxRate': 'Pajak',
  'bo.ap.inv.col.net': 'Neto',
  'bo.ap.inv.col.tax': 'Nilai pajak',
  'bo.ap.inv.overdue': 'Lewat jatuh tempo {days} hari',
  'bo.ap.inv.refreshing': 'Memperbarui…',
  'bo.ap.inv.stale': 'Gagal memperbarui — menampilkan data terakhir yang dimuat.',

  // ---- Shared field labels
  'bo.ap.inv.supplier': 'Pemasok',
  'bo.ap.inv.pickSupplier': 'Pilih pemasok',
  'bo.ap.inv.supplierNumber': 'No. faktur pemasok',
  'bo.ap.inv.supplierNumberHint': 'Sesuai yang tercetak di faktur pemasok.',
  'bo.ap.inv.invoiceDate': 'Tanggal faktur',
  'bo.ap.inv.dueDate': 'Jatuh tempo',
  'bo.ap.inv.dueHint': 'Bawaan: tanggal faktur + {days} hari (termin pembayaran pemasok).',
  'bo.ap.inv.dueHintNoSupplier': 'Bawaan: tanggal faktur + termin pembayaran pemasok.',
  'bo.ap.inv.po': 'Pesanan pembelian (PO)',
  'bo.ap.inv.noPo': 'Tanpa PO',
  'bo.ap.inv.poHint': 'Baris diisi dari PO dan dicocokkan dengannya.',
  'bo.ap.inv.poFixed': 'PO dari faktur yang sudah tercatat tidak dapat diubah.',
  'bo.ap.inv.poOption': '{number} — {total}',
  'bo.ap.inv.poLoading': 'Memuat baris PO…',
  'bo.ap.inv.poLoadFailed': 'Baris PO gagal dimuat. Pilih PO sekali lagi.',
  'bo.ap.inv.posLoadFailed': 'Daftar PO gagal dimuat; catat tanpa PO atau coba lagi nanti.',
  'bo.ap.inv.posEmpty': 'Tidak ada PO yang disetujui dari pemasok ini.',
  'bo.ap.inv.budgetHint':
    'Pos anggaran yang disetujui untuk {period}; nilai neto menjadi realisasi saat diposting.',
  'bo.ap.inv.notes': 'Catatan',
  'bo.ap.inv.noSuppliers': 'Belum ada pemasok aktif. Pemasok dikelola di Stok.',
  'bo.ap.inv.perUnit': 'per {unit}',
  'bo.ap.inv.net': 'Neto',
  'bo.ap.inv.tax': 'Pajak',
  'bo.ap.inv.total': 'Total',
  'bo.ap.inv.outstanding': 'Sisa utang',
  'bo.ap.inv.pending': 'Alokasi menunggu',
  'bo.ap.inv.openToAllocate': 'Bisa dibayar atau dikreditkan',
  'bo.ap.inv.notPostedYet': 'Belum diposting',

  // ---- Form
  'bo.ap.inv.newTitle': 'Catat faktur pemasok',
  'bo.ap.inv.newSubtitle':
    'Salin dari faktur kertas. Disimpan sebagai draf; pencocokan dan persetujuan menyusul.',
  'bo.ap.inv.noManage': 'Mencatat faktur memerlukan peran staf AP (ap.manage).',
  'bo.ap.inv.editTitle': 'Ubah {number}',
  'bo.ap.inv.editSubtitle':
    'Menyimpan mengganti semua baris dan menghapus hasil pencocokan terakhir.',
  'bo.ap.inv.form.headTitle': 'Faktur',
  'bo.ap.inv.form.headDesc': 'Pemasok, nomor, dan tanggal sesuai faktur kertas.',
  'bo.ap.inv.form.linesTitle': 'Baris',
  'bo.ap.inv.form.linesDesc':
    'Baris bebas (ongkos kirim, jasa). Jumlah hingga 3 desimal; harga dalam rupiah per satuan.',
  'bo.ap.inv.form.linesDescPo':
    'Diisi dari PO (jumlah diterima, atau jumlah dipesan bila belum ada penerimaan). Sesuaikan dengan yang ditagihkan pemasok.',
  'bo.ap.inv.form.lineLabel': 'Baris {n}',
  'bo.ap.inv.form.removeLine': 'Hapus baris {n}',
  'bo.ap.inv.form.poLine': 'Baris PO: {item} · dalam {unit}',
  'bo.ap.inv.form.freeLine': 'Baris bebas (tidak ada di PO)',
  'bo.ap.inv.form.description': 'Keterangan',
  'bo.ap.inv.form.qty': 'Jumlah ({unit})',
  'bo.ap.inv.form.unitFree': 'satuan',
  'bo.ap.inv.form.price': 'Harga satuan ({currency})',
  'bo.ap.inv.form.discount': 'Diskon',
  'bo.ap.inv.form.taxRate': 'Pajak %',
  'bo.ap.inv.form.lineNet': 'Neto baris',
  'bo.ap.inv.form.lineTax': 'pajak',
  'bo.ap.inv.form.addLine': 'Tambah baris bebas',
  'bo.ap.inv.form.amountsTitle': 'Nilai sesuai cetakan',
  'bo.ap.inv.form.amountsDesc':
    'Ketik neto dan pajak yang tercetak di faktur; keduanya dicek terhadap baris.',
  'bo.ap.inv.form.useLineTotals': 'Pakai jumlah baris',
  'bo.ap.inv.form.headerNet': 'Neto tercetak ({currency})',
  'bo.ap.inv.form.headerTax': 'Pajak tercetak ({currency})',
  'bo.ap.inv.form.linesSum': 'Baris: {amount}',
  'bo.ap.inv.form.total': 'Total faktur',
  'bo.ap.inv.form.headerMatches': 'Nilai tercetak sama dengan jumlah baris.',
  'bo.ap.inv.form.headerDiff': 'Neto tercetak vs baris:',
  'bo.ap.inv.form.taxDiff': 'pajak:',
  'bo.ap.inv.form.headerOutside': 'di luar toleransi; pencocokan akan menandainya.',
  'bo.ap.inv.form.draftNote': 'Disimpan sebagai draf. Belum menjadi utang sebelum diposting.',
  'bo.ap.inv.form.saveDraft': 'Simpan draf',
  'bo.ap.inv.err.supplier': 'Pilih pemasok.',
  'bo.ap.inv.err.number': 'Isi nomor faktur pemasok (maksimal 60 karakter).',
  'bo.ap.inv.err.date': 'Isi tanggal yang valid.',
  'bo.ap.inv.err.dueBefore': 'Jatuh tempo lebih awal dari tanggal faktur.',
  'bo.ap.inv.err.amount': 'Isi nilai rupiah tanpa desimal.',
  'bo.ap.inv.err.notes': 'Catatan maksimal 500 karakter.',
  'bo.ap.inv.err.noLines': 'Tambahkan minimal satu baris.',
  'bo.ap.inv.err.tooManyLines': 'Satu faktur maksimal 200 baris.',
  'bo.ap.inv.err.desc': 'Isi keterangan baris (maksimal 200 karakter).',
  'bo.ap.inv.err.qty': 'Isi jumlah di atas 0 dengan maksimal 3 desimal.',
  'bo.ap.inv.err.price': 'Isi harga satuan dalam rupiah tanpa desimal.',
  'bo.ap.inv.err.tax': 'Isi tarif pajak 0–100% (maksimal 2 desimal).',
  'bo.ap.inv.err.discount': 'Diskon lebih besar dari nilai baris.',
  'bo.ap.inv.err.matchTolerance':
    'Pencocokan di luar toleransi dan belum disetujui sebagai pengecualian. Cocokkan ulang atau sengketakan faktur.',
  'bo.ap.inv.err.hasAllocations':
    'Ada pembayaran atau nota kredit yang dialokasikan ke faktur ini. Tolak atau batalkan dulu.',
  'bo.ap.inv.dup.title': 'Nomor faktur pemasok ini sudah tercatat',
  'bo.ap.inv.dup.body': 'Pemasok yang sama punya faktur (tidak dibatalkan) dengan nomor ini:',
  'bo.ap.inv.dup.open': 'buka {number}',
  'bo.ap.inv.dup.field': 'Sudah tercatat untuk pemasok ini.',
  'bo.ap.inv.dup.override': 'Tetap catat sebagai pengecualian terkendali',
  'bo.ap.inv.dup.overrideHint':
    'Hanya bila pemasok memang menerbitkan dua faktur dengan satu nomor. Alasan disimpan di faktur dan di jejak audit.',
  'bo.ap.inv.dup.reason': 'Alasan pengecualian',
  'bo.ap.inv.dup.reasonInvalid': 'Tulis alasan 3 sampai 300 karakter.',
  'bo.ap.inv.dup.noOverride':
    'Periksa faktur yang sudah ada. Hanya kepala keuangan (ap.approve) yang dapat mencatat pengecualian.',
  'bo.ap.inv.dup.saveOverride': 'Simpan sebagai pengecualian',
  'bo.ap.inv.created': 'Faktur {number} disimpan sebagai draf.',
  'bo.ap.inv.saved': 'Faktur {number} disimpan.',

  // ---- Detail
  'bo.ap.inv.backToList': 'Semua faktur',
  'bo.ap.inv.detailTitle': 'Faktur pemasok',
  'bo.ap.inv.detailSubtitle': '{supplier} · no. faktur {number}',
  'bo.ap.inv.readOnlyDetail': 'Hanya baca: mengubah faktur ini memerlukan peran staf AP.',
  'bo.ap.inv.factsTitle': 'Rincian',
  'bo.ap.inv.factsDesc': 'Apa yang dicatat, oleh siapa, serta PO dan anggarannya.',
  'bo.ap.inv.amountsTitle': 'Nilai',
  'bo.ap.inv.amountsDesc':
    'Sisa utang menghitung pembayaran terverifikasi dan nota kredit yang diposting; yang menunggu masih perlu orang kedua.',
  'bo.ap.inv.matchMode': 'Pencocokan',
  'bo.ap.inv.mode.two_way': '2 arah (PO)',
  'bo.ap.inv.mode.three_way': '3 arah (PO + penerimaan)',
  'bo.ap.inv.mode.none': 'Tanpa PO — tidak dicocokkan',
  'bo.ap.inv.matchStatus.not_matched': 'Belum dicocokkan',
  'bo.ap.inv.matchStatus.matched': 'Cocok',
  'bo.ap.inv.matchStatus.exception': 'Pengecualian',
  'bo.ap.inv.matchStatus.overridden': 'Pengecualian disetujui',
  'bo.ap.inv.createdBy': 'Dicatat oleh',
  'bo.ap.inv.postedBy': 'Diposting oleh',
  'bo.ap.inv.reasonText': 'Alasan: {reason}',
  'bo.ap.inv.voidedAt': 'Dibatalkan pada {time}',
  'bo.ap.inv.disputedTitle': 'Disengketakan',
  'bo.ap.inv.disputedHelp':
    'Selesaikan dengan pemasok, lalu buka kembali sebagai draf untuk dikoreksi dan diajukan ulang.',
  'bo.ap.inv.disputedHelpReadOnly': 'Staf AP membukanya kembali setelah selesai dengan pemasok.',
  'bo.ap.inv.dupOverrideTitle': 'Dicatat sebagai pengecualian aturan nomor ganda',
  'bo.ap.inv.exceptionReviewTitle': 'Pengecualian pencocokan',
  'bo.ap.inv.exceptionReviewBody':
    'Persetujuan memuat langkah tambahan “Match exception” untuk kepala keuangan; menyetujuinya mengesampingkan pengecualian.',
  'bo.ap.inv.exceptionDraftTitle': 'Pencocokan menemukan pengecualian',
  'bo.ap.inv.exceptionDraftBody':
    'Koreksi baris atau minta nota kredit ke pemasok. Bila tetap diajukan, ada langkah persetujuan tambahan “Match exception”.',
  'bo.ap.inv.exceptionStepNote':
    'Pencocokan di luar toleransi: permintaan ini punya langkah tambahan “Match exception”.',
  'bo.ap.inv.draftNote': 'Draf: cocokkan dengan PO, lalu ajukan untuk persetujuan.',
  'bo.ap.inv.draftNoteReadOnly': 'Draf: staf AP mengajukannya untuk persetujuan.',
  'bo.ap.inv.approvedNote': 'Disetujui: posting mencatat utang dan realisasi anggaran.',
  'bo.ap.inv.linesTitle': 'Baris faktur',
  'bo.ap.inv.linesDesc': 'Sesuai yang dicatat; neto setelah diskon, pajak per baris.',
  'bo.ap.inv.linesEmpty': 'Tidak ada baris.',
  'bo.ap.inv.linesSum': 'Jumlah baris',
  'bo.ap.inv.lineOnPo': 'Ada di PO',

  // ---- Match view
  'bo.ap.inv.match': 'Cocokkan',
  'bo.ap.inv.matching': 'Mencocokkan…',
  'bo.ap.inv.matchedOk': 'Cocok, dalam toleransi.',
  'bo.ap.inv.matchedException': 'Dicocokkan dengan pengecualian — lihat alasan per baris.',
  'bo.ap.inv.match.title': 'Dipesan · diterima · ditagih',
  'bo.ap.inv.match.descThree':
    '3 arah: jumlah yang ditagih dicek terhadap jumlah dipesan dan diterima, harganya terhadap PO.',
  'bo.ap.inv.match.descTwo': '2 arah: jumlah dan harga yang ditagih hanya dicek terhadap PO.',
  'bo.ap.inv.match.descNone': 'Faktur tanpa PO tidak dicocokkan.',
  'bo.ap.inv.match.tolerance':
    'Toleransi: harga ±{price}%, jumlah +{qty}%, nilai header ±{amount}.',
  'bo.ap.inv.match.runAt': 'Terakhir dicocokkan {time}.',
  'bo.ap.inv.match.noPo': 'Tanpa PO — tidak ada pembanding.',
  'bo.ap.inv.match.notRun':
    'Belum dicocokkan. “Cocokkan” membandingkan tiap baris dengan PO dan penerimaan barang.',
  'bo.ap.inv.match.ordered': 'Dipesan (PO)',
  'bo.ap.inv.match.received': 'Diterima',
  'bo.ap.inv.match.invoiced': 'Ditagih',
  'bo.ap.inv.match.variance': 'Selisih nilai',
  'bo.ap.inv.match.result': 'Hasil',
  'bo.ap.inv.match.ok': 'Dalam toleransi',
  'bo.ap.inv.match.freeLine': 'Tidak ada di PO',
  'bo.ap.inv.match.notChecked': 'tidak dicek (2 arah)',
  'bo.ap.inv.match.cumulative': 'termasuk faktur sebelumnya:',
  'bo.ap.inv.match.qtyVar': 'Jumlah',
  'bo.ap.inv.match.priceVar': 'Harga/satuan',
  'bo.ap.inv.match.headerRow': 'Nilai header',
  'bo.ap.inv.match.headerRowHint': 'Neto tercetak vs jumlah baris',
  'bo.ap.inv.match.linesNet': 'Baris',
  'bo.ap.inv.match.totalVariance': 'Total selisih nilai baris:',
  'bo.ap.inv.match.allOk': 'semua baris dalam toleransi',
  'bo.ap.inv.match.exceptions': '{count} dengan pengecualian',

  // ---- Actions
  'bo.ap.inv.edit': 'Ubah draf',
  'bo.ap.inv.submit': 'Ajukan persetujuan',
  'bo.ap.inv.submitting': 'Mengajukan…',
  'bo.ap.inv.submitTitle': 'Ajukan {number} untuk persetujuan?',
  'bo.ap.inv.submitBody':
    'Faktur senilai {total} masuk ke langkah persetujuan sesuai kebijakan dan tidak dapat diubah lagi.',
  'bo.ap.inv.submitMatchWarning':
    'Faktur dicocokkan dengan PO terlebih dahulu; pengecualian menambah langkah “Match exception”.',
  'bo.ap.inv.submitted': 'Faktur {number} diajukan untuk persetujuan.',
  'bo.ap.inv.approvedNow': 'Faktur {number} disetujui (tidak ada langkah persetujuan).',
  'bo.ap.inv.post': 'Posting',
  'bo.ap.inv.posting': 'Memposting…',
  'bo.ap.inv.postTitle': 'Posting {number}?',
  'bo.ap.inv.postBody':
    'Posting mencatat utang {total} kepada {supplier}. Setelah itu faktur tidak dapat diubah.',
  'bo.ap.inv.postBudgetNote':
    'Nilai neto menjadi realisasi di pos anggaran dan melepas komitmen PO.',
  'bo.ap.inv.posted': 'Faktur {number} diposting.',
  'bo.ap.inv.dispute': 'Sengketakan',
  'bo.ap.inv.disputing': 'Menyimpan…',
  'bo.ap.inv.disputeTitle': 'Sengketakan {number}?',
  'bo.ap.inv.disputeBody':
    'Persetujuan yang berjalan dibatalkan. Faktur menunggu sampai selesai dengan pemasok.',
  'bo.ap.inv.disputed': 'Faktur {number} disengketakan.',
  'bo.ap.inv.reopen': 'Buka kembali sebagai draf',
  'bo.ap.inv.reopening': 'Membuka kembali…',
  'bo.ap.inv.reopenTitle': 'Buka kembali {number}?',
  'bo.ap.inv.reopenBody':
    'Faktur kembali menjadi draf agar dapat dikoreksi, dicocokkan, dan diajukan.',
  'bo.ap.inv.reopened': 'Faktur {number} dibuka kembali sebagai draf.',
  'bo.ap.inv.void': 'Batalkan',
  'bo.ap.inv.voiding': 'Membatalkan…',
  'bo.ap.inv.voidTitle': 'Batalkan {number}?',
  'bo.ap.inv.voidBody': 'Faktur yang dibatalkan tetap tercatat tetapi tidak akan pernah dibayar.',
  'bo.ap.inv.voidPostedWarning': 'Faktur sudah diposting: utang dan realisasi anggarannya dibalik.',
  'bo.ap.inv.voidReviewWarning': 'Permintaan persetujuan yang berjalan dibatalkan.',
  'bo.ap.inv.voided': 'Faktur {number} dibatalkan.',
  'bo.ap.inv.reason': 'Alasan',

  // ---- Payments on the invoice
  'bo.ap.inv.paymentsTitle': 'Pembayaran',
  'bo.ap.inv.paymentsDesc':
    'Pembayaran yang dialokasikan ke faktur ini. Hanya pembayaran terverifikasi yang mengurangi sisa utang.',
  'bo.ap.inv.paymentsNotPosted': 'Pembayaran dapat dialokasikan setelah faktur diposting.',
  'bo.ap.inv.paymentsEmpty':
    'Belum ada pembayaran yang dialokasikan. Pembayaran dicatat di Pembayaran.',
  'bo.ap.inv.pay.document': 'Pembayaran',
  'bo.ap.inv.pay.date': 'Tanggal',
  'bo.ap.inv.pay.reference': 'Referensi',
  'bo.ap.inv.pay.applied': 'Dialokasikan ke sini',
  'bo.ap.inv.pay.status': 'Status',
  'bo.ap.inv.payStatus.pending_verification': 'Menunggu verifikasi',
  'bo.ap.inv.payStatus.verified': 'Terverifikasi',
  'bo.ap.inv.payStatus.rejected': 'Ditolak',

  // ---- Credit notes
  'bo.ap.credit.title': 'Nota kredit',
  'bo.ap.credit.subtitle':
    'Nota kredit pemasok di {branch}. Dicatat staf AP, diposting oleh orang lain.',
  'bo.ap.credit.readOnly': 'Hanya baca: mencatat nota kredit memerlukan peran staf AP.',
  'bo.ap.credit.readOnlyApprover':
    'Anda memposting nota kredit yang dicatat staf AP; mencatatnya memerlukan peran staf AP.',
  'bo.ap.credit.noPermission': 'Peran Anda tidak dapat melihat nota kredit di cabang ini.',
  'bo.ap.credit.listTitle': 'Nota kredit',
  'bo.ap.credit.listDesc':
    'Terbaru di atas. Nota kredit yang diposting mengurangi sisa utang faktur.',
  'bo.ap.credit.statusFilter': 'Saring menurut status',
  'bo.ap.credit.status.draft': 'Draf',
  'bo.ap.credit.status.posted': 'Diposting',
  'bo.ap.credit.status.voided': 'Dibatalkan',
  'bo.ap.credit.empty': 'Belum ada nota kredit. Catat lewat “Buat nota kredit”.',
  'bo.ap.credit.emptyReadOnly': 'Belum ada nota kredit. Nota muncul setelah dicatat staf AP.',
  'bo.ap.credit.emptyFiltered': 'Tidak ada nota kredit dengan status ini.',
  'bo.ap.credit.emptyInvoice': 'Belum ada nota kredit untuk faktur ini.',
  'bo.ap.credit.emptyNotPosted': 'Nota kredit dapat dicatat setelah faktur diposting.',
  'bo.ap.credit.forInvoiceTitle': 'Nota kredit',
  'bo.ap.credit.forInvoiceDesc': 'Kredit dari pemasok atas faktur ini.',
  'bo.ap.credit.col.number': 'Nota kredit',
  'bo.ap.credit.col.amount': 'Nilai',
  'bo.ap.credit.col.reason': 'Alasan',
  'bo.ap.credit.col.status': 'Status',
  'bo.ap.credit.col.actions': 'Tindakan',
  'bo.ap.credit.enteredBy': 'Dicatat oleh {name}',
  'bo.ap.credit.postedBy': 'Diposting oleh {name} · {time}',
  'bo.ap.credit.create': 'Buat nota kredit',
  'bo.ap.credit.createTitle': 'Buat nota kredit',
  'bo.ap.credit.createDesc':
    'Untuk satu faktur yang sudah diposting, paling banyak sebesar sisa terbukanya.',
  'bo.ap.credit.forInvoice': 'Faktur',
  'bo.ap.credit.invoice': 'Faktur',
  'bo.ap.credit.invoiceHint': 'Faktur pemasok ini yang sudah diposting dan masih ada sisanya.',
  'bo.ap.credit.pickInvoice': 'Pilih faktur',
  'bo.ap.credit.noOpenInvoices': 'Tidak ada faktur terbuka dari pemasok ini',
  'bo.ap.credit.invoiceOption': '{number} · no. {supplierNumber} — sisa {open}',
  'bo.ap.credit.openAmount': 'Sisa terbuka di faktur:',
  'bo.ap.credit.number': 'No. nota kredit',
  'bo.ap.credit.numberHint': 'Sesuai yang tercetak di nota kredit pemasok.',
  'bo.ap.credit.amount': 'Nilai ({currency})',
  'bo.ap.credit.reason': 'Alasan',
  'bo.ap.credit.reasonHint': 'Misalnya koreksi harga atau barang dikembalikan.',
  'bo.ap.credit.save': 'Simpan nota kredit',
  'bo.ap.credit.sodNote':
    'Pemisahan tugas: orang yang mencatat nota kredit tidak dapat mempostingnya.',
  'bo.ap.credit.ownNote': 'Anda yang mencatat — orang lain yang memposting.',
  'bo.ap.credit.err.invoice': 'Pilih faktur.',
  'bo.ap.credit.err.number': 'Isi nomor nota kredit (maksimal 60 karakter).',
  'bo.ap.credit.err.amount': 'Isi nilai di atas 0 dalam rupiah tanpa desimal.',
  'bo.ap.credit.err.over': 'Nilainya melebihi sisa terbuka di faktur.',
  'bo.ap.credit.err.reason': 'Tulis alasan 3 sampai 300 karakter.',
  'bo.ap.credit.dupNumber': 'Nomor nota kredit ini sudah tercatat.',
  'bo.ap.credit.overOpen': 'Melebihi sisa terbuka {open} di faktur.',
  'bo.ap.credit.overOpenGeneric': 'Melebihi sisa terbuka di faktur.',
  'bo.ap.credit.selfPost':
    'Anda yang mencatat nota kredit ini; orang lain dengan wewenang persetujuan AP harus mempostingnya.',
  'bo.ap.credit.created': 'Nota kredit {number} disimpan sebagai draf.',
  'bo.ap.credit.post': 'Posting',
  'bo.ap.credit.posting': 'Memposting…',
  'bo.ap.credit.postTitle': 'Posting nota kredit {number}?',
  'bo.ap.credit.postBody': '{amount} dikreditkan ke faktur {invoice} dan mengurangi sisa utangnya.',
  'bo.ap.credit.posted': 'Nota kredit {number} diposting.',
  'bo.ap.credit.void': 'Batalkan',
  'bo.ap.credit.voiding': 'Membatalkan…',
  'bo.ap.credit.voidTitle': 'Batalkan nota kredit {number}?',
  'bo.ap.credit.voidBody': 'Draf dibatalkan dan nilainya dilepas dari faktur.',
  'bo.ap.credit.voided': 'Nota kredit {number} dibatalkan.',
};
